import { render, staticRenderFns } from "./foodDetail.vue?vue&type=template&id=064717bb&scoped=true"
import script from "./foodDetail.vue?vue&type=script&lang=js"
export * from "./foodDetail.vue?vue&type=script&lang=js"
import style0 from "./foodDetail.vue?vue&type=style&index=0&id=064717bb&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "064717bb",
  null
  
)

export default component.exports